import type { CurrencyCode } from "@/models/currencyCode"

import { CURRENCY_LOCAL_STORAGE_KEY, DEFAULT_CURRENCY } from "./constants"
import { isSupportedCurrencyCode } from "./currency"

// Still necessary in order to send currency in server api requests
export const getSavedCurrency = (): CurrencyCode => {
  const savedCurrency = localStorage.getItem(
    CURRENCY_LOCAL_STORAGE_KEY
  ) as CurrencyCode

  const safeSavedCurrency = (
    typeof savedCurrency === "string" ? savedCurrency.replace(/"/g, "") : ""
  ) as CurrencyCode

  // Only return valid saved currency codes
  // If an invalid currency code makes it way into local storage, return the default
  return isSupportedCurrencyCode(safeSavedCurrency)
    ? safeSavedCurrency
    : DEFAULT_CURRENCY
}
